import { Button, Stack } from 'canoe';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import AboveContentDark from '!!react-svg-loader!./assets/AboveContent.svg';
import BelowContentDark from '!!react-svg-loader!./assets/BelowContent.svg';
import ReplaceContentDark from '!!react-svg-loader!./assets/ReplaceContent.svg';
import { ContentPlacement, SelectorLocation } from '@candu-ai/placement/types';
import { SelectCard } from '@candu-ai/placement/ui';
import { CardsContainer } from 'craft/containers/Toolbox/tabs/Placements/components/ui';
import { FormState } from 'craft/containers/Toolbox/tabs/Placements/constants';
import { setPreviewSelectorLocation } from 'craft/state';

interface Props {
  state: FormState;
  onSave: (value?: string) => void;
  onCancel?: VoidFunction;
}

export const InlineSelectorLocationForm = ({ state, onSave, onCancel }: Props) => {
  const dispatch = useDispatch();
  const { values, setFieldValue, dirty } = useFormikContext<ContentPlacement>();

  const [inputValue, setInputValue] = useState(values.location || SelectorLocation.START);

  useEffect(() => {
    dispatch(setPreviewSelectorLocation(inputValue));
    setFieldValue('location', inputValue, false);
  }, [inputValue]);

  return (
    <Stack space="s" spaceAfter="normal">
      <CardsContainer mt="xs">
        <SelectCard
          active={inputValue === SelectorLocation.START}
          onClick={() => setInputValue(SelectorLocation.START)}
          type="button"
          mode="Dark"
        >
          <AboveContentDark />
          Above Content
        </SelectCard>
        <SelectCard
          active={inputValue === SelectorLocation.END}
          onClick={() => setInputValue(SelectorLocation.END)}
          type="button"
          mode="Dark"
        >
          <BelowContentDark />
          Below Content
        </SelectCard>
        <SelectCard
          active={inputValue === SelectorLocation.REPLACE}
          onClick={() => setInputValue(SelectorLocation.REPLACE)}
          type="button"
          mode="Dark"
        >
          <ReplaceContentDark />
          Replace Content
        </SelectCard>
      </CardsContainer>

      <div>
        <Button
          variant="secondary"
          fullWidth
          disabled={state === FormState.UPDATE && !dirty}
          onClick={() => onSave(inputValue)}
        >
          {state === FormState.UPDATE ? 'Update' : 'Start Editing Content'}
        </Button>
        {onCancel && (
          <Button variant="neutral" appearance="outline" fullWidth onClick={onCancel} mt="xs">
            Cancel
          </Button>
        )}
      </div>
    </Stack>
  );
};
